/*
 * Cross-sell - moteur cross-sell unique (grille + encart + tiroir).
 * Lecture panier: GET /cart.js. Les lignes (encart, tiroir) ajoutent en AJAX (onXsellSubmit), sur le
 * contrat d'Horizon (evenement 'cart:update' + sections du tiroir) ; le {% form 'product' %} natif
 * (snippets/xsell-row.liquid) reste le repli sans JS.
 * Filtrage synchrone par atomes: on masque tout candidat partageant un atome avec le panier.
 * Chargé une fois globalement via snippets/xsell-head.liquid.
 */
(function () {
  if (window.__xsell) return;
  window.__xsell = true;

  var ATOMS = window.XSELL_ATOMS || {};

  function parseAtoms(str) {
    try { var a = JSON.parse(str || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function getCart(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () { cb({ items: [], item_count: 0 }); });
  }
  // Construit l'ensemble POSSEDE (atomes) + les handles deja au panier.
  function ownedFromCart(cart, currentAtoms) {
    var owned = Object.create(null);
    var handles = Object.create(null);
    (cart.items || []).forEach(function (it) {
      handles[it.handle] = 1;
      var a = ATOMS[it.product_id] || ATOMS[String(it.product_id)] || [String(it.product_id)];
      a.forEach(function (x) { owned[x] = 1; });
    });
    (currentAtoms || []).forEach(function (x) { owned[x] = 1; });
    return { owned: owned, handles: handles };
  }
  function suppressed(cand, ctx, current, noPacks) {
    if (current && cand.handle === current) return true;
    if (ctx.handles[cand.handle]) return true;
    if (noPacks && cand.pack) return true;
    for (var i = 0; i < cand.atoms.length; i++) {
      if (ctx.owned[cand.atoms[i]]) return true;
    }
    return false;
  }
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  function esc(s) {
    s = String(s == null ? '' : s);
    return s.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
  }
  function cartToken(cart) {
    return (cart.item_count || 0) + ':' + (cart.items || []).map(function (i) { return i.id + 'x' + i.quantity; }).join(',');
  }

  /* ---------- GRILLE bas de fiche (recommandations ; cartes-lien ; packs autorises) ---------- */
  function card(p) {
    var media = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" loading="lazy">'
                      : '<span class="xsell-shopcard__ph">' + esc(p.t) + '</span>';
    // Extras : seconde image au survol + vignette produit component (+)
    var hover = p.img2 ? '<span class="xsell-hover" aria-hidden="true"><img src="' + esc(p.img2) + '" alt="" loading="lazy"></span>' : '';
    var comp = p.comp ? '<span class="xsell-comp" aria-hidden="true"><span class="xsell-comp__plus">+</span><span class="xsell-comp__img"><img src="' + esc(p.comp) + '" alt="" loading="lazy"></span></span>' : '';
    var badge = p.promo ? '<span class="xsell-shopcard__badge">' + esc(p.promo) + '</span>' : '';
    return '<a class="xsell-shopcard" href="' + esc(p.u) + '">'
      + '<div class="xsell-shopcard__media">' + media + hover + comp + badge + '</div>'
      + '<div class="xsell-shopcard__cap"><span class="xsell-shopcard__name">' + esc(p.t) + '</span>'
      + '<span class="xsell-shopcard__price">' + esc(p.pr) + '</span></div></a>';
  }
  function grid() {
    var host = document.querySelector('[data-xsell-grid]');
    if (!host) return;
    var poolEl = host.querySelector('[data-xsell-grid-pool]');
    var listEl = host.querySelector('[data-xsell-grid-list]');
    if (!poolEl || !listEl) return;
    var pool = [];
    try { pool = JSON.parse(poolEl.textContent) || []; } catch (e) { pool = []; }
    if (!pool.length) { host.hidden = true; return; }
    var current = host.getAttribute('data-current') || currentHandle();
    var max = parseInt(host.getAttribute('data-max') || '4', 10);
    var min = parseInt(host.getAttribute('data-min') || '1', 10);
    /* Atomes de la fiche courante : lus sur l'hote (data-atoms rendu serveur = xsell.bundle_atoms du produit),
       pour que le filtrage tienne compte du produit visite (pack inclus) meme s'il n'est pas dans le pool. */
    var currentAtoms = parseAtoms(host.getAttribute('data-atoms'));
    if (!currentAtoms.length) pool.forEach(function (p) { if (p.h === current) currentAtoms = p.a || []; });
    getCart(function (cart) {
      var ctx = ownedFromCart(cart, currentAtoms);
      var items = pool.filter(function (p) {
        return !suppressed({ handle: p.h, atoms: p.a || [], pack: p.pack }, ctx, current, false);
      });
      /* Mise en avant des packs : tri STABLE packs d'abord, puis produits seuls (le serveur les emet deja
         dans cet ordre ; on securise si la collection source est reordonnee). Puis on coupe a `max`. */
      items.sort(function (a, b) { return (b.pack ? 1 : 0) - (a.pack ? 1 : 0); });
      items = items.slice(0, max);
      if (items.length < min) { host.hidden = true; return; }
      listEl.innerHTML = items.map(card).join('');
      host.hidden = false;
      if ((host.getAttribute('data-layout') || 'grid') === 'slider') setupGridSlider(host, listEl);
    });
  }

  /* Slider horizontal (defilement a boucle) : fleches + scroll-snap. Reutilise
     le style des fleches du tiroir (.xsell-xg__nav / .xsell-xg__arrow). */
  function setupGridSlider(host, list) {
    if (host.querySelector('[data-xsell-grid-nav]')) return;
    list.classList.add('xsell__grid--slider');
    var head = host.querySelector('.xsell__head');
    if (!head) { head = document.createElement('div'); head.className = 'xsell__head'; host.insertBefore(head, list); }
    head.classList.add('xsell__head--slider');
    var nav = document.createElement('div');
    nav.className = 'xsell-xg__nav';
    nav.setAttribute('data-xsell-grid-nav', '');
    nav.innerHTML = '<button type="button" class="xsell-xg__arrow xsell-xg__arrow--prev" aria-label="Precedent"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5 L8 12 L15 19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      + '<button type="button" class="xsell-xg__arrow xsell-xg__arrow--next" aria-label="Suivant"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5 L16 12 L9 19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    head.appendChild(nav);
    var prev = nav.firstElementChild, next = nav.lastElementChild;
    function step() {
      var f = list.querySelector('.xsell-shopcard');
      if (!f) return list.clientWidth;
      var cs = getComputedStyle(list);
      return f.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 0);
    }
    /* Indicateur de scroll sous le slider : piste + pouce proportionnel a la
       portion visible, position = progression du defilement. */
    var track = document.createElement('div');
    track.className = 'xsell__scroll';
    track.setAttribute('data-xsell-scroll', '');
    var thumb = document.createElement('span');
    thumb.className = 'xsell__scroll-thumb';
    track.appendChild(thumb);
    list.insertAdjacentElement('afterend', track);
    function updateScroll() {
      var max = list.scrollWidth - list.clientWidth;
      if (max <= 2) { thumb.style.width = '100%'; thumb.style.left = '0'; return; }
      var widthPct = (list.clientWidth / list.scrollWidth) * 100;
      thumb.style.width = widthPct + '%';
      thumb.style.left = ((list.scrollLeft / max) * (100 - widthPct)) + '%';
    }
    function sync() {
      var over = list.scrollWidth > list.clientWidth + 2;
      nav.hidden = !over;
      track.hidden = !over;
      updateScroll();
    }
    prev.addEventListener('click', function () {
      if (list.scrollLeft <= 2) list.scrollTo({ left: list.scrollWidth, behavior: 'smooth' });
      else list.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (list.scrollLeft + list.clientWidth >= list.scrollWidth - 2) list.scrollTo({ left: 0, behavior: 'smooth' });
      else list.scrollBy({ left: step(), behavior: 'smooth' });
    });
    list.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- Deplacement de lignes (encart + tiroir) ----------
     Les lignes sont rendues serveur (avec form natif) dans un reservoir persistant.
     On DEPLACE les survivantes (appendChild) : jamais recopiees => images conservees. */
  function collectRows(reservoir) {
    var rows = [];
    reservoir.querySelectorAll('[data-xsell-xrow]').forEach(function (row) {
      rows.push({
        node: row,
        handle: row.getAttribute('data-handle'),
        atoms: parseAtoms(row.getAttribute('data-atoms')),
        pack: row.getAttribute('data-pack') === 'true'
      });
    });
    return rows;
  }
  function fillList(listNode, reservoir, rows, ctx, current, noPacks, max) {
    rows.forEach(function (r) { r.node.hidden = true; reservoir.appendChild(r.node); });
    var shown = 0;
    for (var i = 0; i < rows.length && shown < max; i++) {
      var r = rows[i];
      if (suppressed(r, ctx, current, noPacks)) continue;
      r.node.hidden = false;
      listNode.appendChild(r.node);
      shown++;
    }
    return shown;
  }

  /* ENCART PDP : insere pres du bloc d'achat, calcule une fois au chargement. */
  function encart() {
    var host = document.querySelector('[data-xsell-encart]');
    if (!host) return;
    var reservoir = host.querySelector('[data-xsell-encart-reservoir]');
    if (!reservoir) return;
    var rows = collectRows(reservoir);
    if (!rows.length) return;
    var current = host.getAttribute('data-current') || currentHandle();
    var max = parseInt(host.getAttribute('data-max') || '2', 10);
    var min = parseInt(host.getAttribute('data-min') || '1', 10);
    var title = host.getAttribute('data-title') || '';
    var titleSize = host.getAttribute('data-title-size') || '';
    var titleFont = host.getAttribute('data-title-font') || 'heading';
    var padTop = host.getAttribute('data-pad-top');
    var padBottom = host.getAttribute('data-pad-bottom');
    var sel = host.getAttribute('data-anchor') || '';
    /* Ancre = le VRAI formulaire produit de la fiche. On exclut les formulaires des lignes cross-sell
       (.xsell-xrow__pf) et tout ce qui est dans le tiroir / un reservoir : sinon, comme le groupe
       panier est rendu AVANT le contenu, querySelector('product-form') attrape une ligne du tiroir
       -> l'encart s'insere au mauvais endroit (disposition cassee). */
    var EXCL = 'cart-drawer,[data-xsell-cart],[data-xsell-cart-reservoir],[data-xsell-encart-reservoir]';
    function pickForm(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.classList && n.classList.contains('xsell-xrow__pf')) continue;
        if (n.classList && n.classList.contains('xsell-xrow__form')) continue;
        if (n.closest && n.closest(EXCL)) continue;
        return n;
      }
      return null;
    }
    /* Positionnement : 'inplace' = a l'emplacement de la section (l'hote), tel
       que place dans l'editeur ; 'auto' (defaut) = deplace pres du bloc d'achat. */
    var placement = host.getAttribute('data-placement') || 'auto';
    var anchor;
    if (placement === 'inplace') {
      anchor = host;
    } else {
      anchor = (sel && document.querySelector(sel))
        || pickForm(document.querySelectorAll('product-form'))
        || pickForm(document.querySelectorAll('form[action$="/cart/add"]'));
    }
    if (!anchor || !anchor.parentNode) return;
    if (document.querySelector('[data-xsell-encart-live]')) return;
    /* Atomes de la fiche courante : lus sur l'hote (data-atoms rendu serveur). L'encart exclut le produit
       courant du reservoir, donc on ne peut PAS retrouver ses atomes dans les lignes -> data-atoms est la
       seule source fiable (pack inclus). Repli sur le reservoir par securite. */
    var currentAtoms = parseAtoms(host.getAttribute('data-atoms'));
    if (!currentAtoms.length) rows.forEach(function (r) { if (r.handle === current) currentAtoms = r.atoms; });
    getCart(function (cart) {
      if (document.querySelector('[data-xsell-encart-live]')) return;
      var ctx = ownedFromCart(cart, currentAtoms);
      var box = document.createElement('div');
      box.className = 'xsell xsell-xg xsell-xg--encart';
      box.setAttribute('data-xsell-encart-live', '');
      if (padTop !== null && padTop !== '') box.style.marginTop = parseInt(padTop, 10) + 'px';
      if (padBottom !== null && padBottom !== '') box.style.marginBottom = parseInt(padBottom, 10) + 'px';
      if (title) {
        var h = document.createElement('div');
        h.className = 'xsell-xg__title';
        h.textContent = title;
        if (titleSize) h.style.fontSize = parseInt(titleSize, 10) + 'px';
        h.style.fontFamily = (titleFont === 'body') ? 'var(--font-body--family)' : 'var(--font-primary--family)';
        box.appendChild(h);
      }
      var list = document.createElement('div');
      list.className = 'xsell-xg__row';
      var n = fillList(list, reservoir, rows, ctx, current, true, max);
      if (n < min) return;
      box.appendChild(list);
      /* Inserer APRES la ligne de reassurance si elle existe (sinon juste apres le formulaire),
         pour que le cross-sell reste sous la reassurance. */
      var ref = anchor;
      if (placement !== 'inplace') {
        var scope = (anchor.closest && anchor.closest('.shopify-section, main, .product-section')) || document;
        var reass = scope.querySelector('.xsell-reassure');
        if (reass && reass.parentNode && (anchor.compareDocumentPosition(reass) & 4)) ref = reass; /* 4 = FOLLOWING */
        /* Jamais DANS un composant qui gere lui-meme la soumission (Horizon : <product-form-component
           on:submit>) : sa delegation d'evenements attribuait le formulaire de la ligne au produit de la
           fiche -> le produit principal etait ajoute au panier a la place / en plus du cross-sell. */
        var owner = ref.parentNode.closest && ref.parentNode.closest('[on\\:submit]');
        if (owner && owner.parentNode) ref = owner;
      }
      ref.parentNode.insertBefore(box, ref.nextSibling);
    });
  }

  /* TIROIR : hote persistant reinsere par MutationObserver ; reshuffle sur changement de panier. */
  function cartDrawer() {
    var host = document.querySelector('[data-xsell-cart]');
    if (!host) return;
    var reservoir = host.querySelector('[data-xsell-cart-reservoir]');
    if (!reservoir) return;
    var rows = collectRows(reservoir);
    if (!rows.length) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var max = parseInt(host.getAttribute('data-max') || '3', 10);
    var min = parseInt(host.getAttribute('data-min') || '1', 10);
    var title = host.getAttribute('data-title') || '';
    var insertSel = host.getAttribute('data-insert') || '';

    var block = document.createElement('div');
    block.className = 'xsell xsell-xg xsell-xg--drawer';
    block.setAttribute('data-xsell-cart-live', '');
    // En-tete : titre + fleches dessinees (defilement produit par produit ; la barre de defilement est masquee en CSS)
    var head = document.createElement('div');
    head.className = 'xsell-xg__head';
    if (title) {
      var h = document.createElement('div');
      h.className = 'xsell-xg__title';
      h.textContent = title;
      head.appendChild(h);
    }
    var nav = document.createElement('div');
    nav.className = 'xsell-xg__nav';
    nav.innerHTML = '<button type="button" class="xsell-xg__arrow xsell-xg__arrow--prev" aria-label="' + esc(host.getAttribute('data-label-prev') || 'Produit precedent') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5 L8 12 L15 19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      + '<button type="button" class="xsell-xg__arrow xsell-xg__arrow--next" aria-label="' + esc(host.getAttribute('data-label-next') || 'Produit suivant') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5 L16 12 L9 19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    head.appendChild(nav);
    block.appendChild(head);
    var list = document.createElement('div');
    list.className = 'xsell-xg__row';
    block.appendChild(list);
    block._empty = true;
    var prev = nav.firstElementChild, next = nav.lastElementChild;
    function step() {
      var first = list.querySelector('.xsell-xrow:not([hidden])');
      if (!first) return list.clientWidth;
      var cs = getComputedStyle(list);
      return first.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 8);
    }
    function state() {
      var over = list.scrollWidth > list.clientWidth + 2;
      nav.hidden = !over;
      if (!over) return;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
    list.addEventListener('scroll', state, { passive: true });
    window.addEventListener('resize', state);
    block._state = state;

    var lastToken = null;
    var pending = false;

    function place() {
      if (!drawer.classList.contains('is-open')) return;
      if (block._empty) { if (block.parentNode) block.parentNode.removeChild(block); return; }
      if (block.parentNode) return;
      var target = (insertSel && drawer.querySelector(insertSel)) || drawer.querySelector('.cart-drawer__footer');
      if (target && target.parentNode) target.parentNode.insertBefore(block, target);
      else (drawer.querySelector('[data-xsell-cart-anchor]') || drawer).appendChild(block);
      requestAnimationFrame(function () { if (block._state) block._state(); });
    }
    function tick() {
      if (!drawer.classList.contains('is-open')) return;
      getCart(function (cart) {
        var tok = cartToken(cart);
        if (tok !== lastToken) {
          var ctx = ownedFromCart(cart, []);
          var n = fillList(list, reservoir, rows, ctx, '', true, max);
          block._empty = (n < min) || !(cart.item_count > 0);
          lastToken = tok;
          list.scrollLeft = 0;
        }
        place();
        if (block._state) block._state();
      });
    }

    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; tick(); });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });

    if (drawer.classList.contains('is-open')) tick();
  }

  /* Ajout AJAX depuis une ligne cross-sell : reproduit le contrat d'Horizon (cf. assets/product-form.js) :
     POST Theme.routes.cart_add_url avec les sections des <cart-items-component>, puis UN evenement
     'cart:update' portant ces sections -> le tiroir se re-rend (morph), la pastille prend le nouveau total
     et le tiroir s'ouvre (attribut auto-open), SANS redirection vers /cart. Ecoute en capture sur window
     + stopImmediatePropagation : passe AVANT la delegation d'Horizon (capture sur document), qui sinon
     attribuerait la soumission au <product-form-component> parent (ajout du produit principal), et
     neutralise le POST natif du {% form 'product' %} (la redirection). */
  function cartAddUrl(){ return (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js'; }
  function onXsellSubmit(e){
    var form = e.target;
    if(!form || !form.classList || !form.classList.contains('xsell-xrow__form')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd; try{ fd = new FormData(form); }catch(_){ return; }
    var id = fd.get('id'); if(!id) return;
    var item = { id: id, quantity: 1 }, props = {}, hasProps = false;
    fd.forEach(function(v,k){ var m=/^properties\[(.+)\]$/.exec(k); if(m){ props[m[1]]=v; hasProps=true; } });
    if(hasProps) item.properties = props;
    var sections = [];
    document.querySelectorAll('cart-items-component').forEach(function(c){
      var sid = c.dataset && c.dataset.sectionId;
      if(sid && sections.indexOf(sid) < 0) sections.push(sid);
    });
    sections.push('auto-gifts');
    var btn = form.querySelector('[name="add"],button[type="submit"]');
    if(btn){ btn.classList.add('is-loading'); btn.disabled = true; }
    function done(){ if(btn){ btn.classList.remove('is-loading'); btn.disabled = false; } }
    fetch(cartAddUrl(), {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ items:[item], sections: sections.join(',') })
    }).then(function(r){ return r.json().catch(function(){ return null; }); }).then(function(data){
      done();
      if(data && (data.status >= 400 || data.status === 'bad_request')){
        try{ document.dispatchEvent(new CustomEvent('toast:open',{detail:{type:'error',message:(data.description||data.message||'')}})); }catch(_){}
        return;
      }
      if(/\/cart(\/|$|\?)/.test(location.pathname)){ location.reload(); return; }
      /* Total relu sur /cart.js (la reponse d'ajout ne donne que la ligne ajoutee). */
      getCart(function(cart){
        var ev; try{ ev=new Event('cart:update',{bubbles:true}); }catch(_){ ev=document.createEvent('Event'); ev.initEvent('cart:update',true,false); }
        ev.detail = { resource:cart, sourceId:'xsell', data:{ itemCount:cart.item_count, source:'xsell', sections:(data&&data.sections)||undefined } };
        document.dispatchEvent(ev);
      });
    }).catch(function(){ done(); });
  }

  function boot() {
    ATOMS = window.XSELL_ATOMS || ATOMS;
    window.addEventListener('submit', onXsellSubmit, true);
    grid();
    encart();
    cartDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
